import { rest } from 'msw'

export const mockCreatePaymentLimitPayload = {
  level: 'ALL_CUSTOMERS' as const,
  accountId: '550e8400-e29b-41d4-a716-446655440001',
  method: 'SEPA_INST',
  limitType: 'DAILY' as const,
  amount: 10000,
  currency: 'EUR',
}

export const mockCreatedPaymentLimit = {
  id: 'new-rule-id',
  limitType: 'DAILY',
  amount: 10000,
  currency: 'EUR',
  qualifiers: {
    accountId: '550e8400-e29b-41d4-a716-446655440001',
    customerId: null,
    walletId: null,
    bankingPartner: null,
    method: 'SEPA_INST',
  },
  owner: 'MERCHANT',
}

export const mockCreatePaymentLimitResponse = {
  id: 'new-rule-id',
  limitType: 'DAILY',
  amount: 10000,
  currency: 'EUR',
  qualifiers: {
    accountId: 'test-account',
    customerId: null,
    walletId: null,
    bankingPartner: null,
    method: 'SEPA_INST',
  },
  owner: 'MERCHANT',
}

const paymentLimitsHandlers = [
  rest.post('*/governance/v1/limits', (_req, res, ctx) => {
    return res(ctx.json(mockCreatedPaymentLimit))
  }),
]

export default paymentLimitsHandlers
